import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrAggressiveBreedsSelect.less';

const SrAggressiveBreedsSelect = ({ isActive, handleClick }) => {

  return (
    <div
      styleName={classNames('SrAggressiveBreedsSelect')}
    >
      <SrBox
        marginRight='12px'
        cursor='pointer'
        onClick={handleClick}
      >
        <div
          styleName={classNames('icon', { isActive })}
        />
      </SrBox>
      <SrText
        font='greycliff'
        fontSize='16px'
        weight={isActive ? '800' : '600'}
        display='block'
        lineHeight='19px'
      >
        Select all aggressive breeds
      </SrText>
    </div>
  );
};

SrAggressiveBreedsSelect.propTypes = {
  isActive: PropTypes.bool.isRequired,
};

SrAggressiveBreedsSelect.displayName = 'SrAgressiveBreedsSelect';

export default SrAggressiveBreedsSelect;
